import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

export class WmTextBold extends wmBase {
    constructor(options: widgetOption<string>[]) {
        super();
        this.options = options;
    }

    build() {
        const uniqValues = [...new Set(this.options.map((opt) => opt.value))];

        const isBold = uniqValues.length === 1 && uniqValues[0] === "bold";
        this.mode = isBold ? "bold" : "";
        const selected = isBold ? "wm_textBold_selected" : "";

        return `
            <div class="wm_dividor"></div>
            <div class="wm_textBold ${selected}">
                <p>B</p>
            </div>
        `;
    }

    init() {
        const item = document.querySelector<HTMLElement>(".wm_textBold");
        item?.removeEventListener("click", this.itemClick, false);
        item?.addEventListener("click", this.itemClick, false);
    }

    itemClick = (e: Event) => {
        const otherSubm = document.querySelector(".widgetSubMenu");
        if (otherSubm) {
            otherSubm.outerHTML = "";
        }

        this.mode = this.mode === "bold" ? "" : "bold";
        this.applyValue(this.options, this.mode);

        const menuItem = document.querySelector<HTMLElement>(".wm_textBold");
        if (!menuItem) return;
        menuItem.classList.toggle("wm_textBold_selected", this.mode === "bold");
    };

    options: widgetOption<string>[] = [];
    mode = "";
}
